import React from "react";
import "./style.css";
import { AuthApis } from "../../apis/AuthApis";
import { useHistory } from "react-router-dom";

export default function Login() {

    const [username, setUsername] = React.useState("");
    const [password, setPassword] = React.useState("");

    const history = useHistory()

    const handleLogin = () => {
        AuthApis.login({ username, password }).then(response => {
            localStorage.setItem('token', JSON.stringify(response.data.token));
            setTimeout(() => {
                history.replace('/dashboard')
            },1000)
        }).catch(error => {
            console.error("Error during login:", error);
        })
    }

    return (
        <div className="login-page">
            <div className="login-card">
                <div className="login-title">Sign in</div>
                <div className="login-subtitle">
                    Welcome back! Please login to continue.
                </div>

                <div className="login-field">
                    <label className="login-label">Email</label>
                    <input
                        type="email"
                        className="login-input"
                        placeholder="you@example.com"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                </div>

                <div className="login-field">
                    <label className="login-label">Password</label>
                    <input
                        type="password"
                        className="login-input"
                        placeholder="••••••••"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </div>

                <button className="login-button" onClick={handleLogin}>Login</button>
            </div>
        </div>
    );
}
